
import React, { useEffect, useState } from 'react'
import AdminNavbar from "./AdminNavbar";
const AdminDashboard = () => {
  const [unlocked, setUnlocked] = useState(false)
  const [showTooltip, setShowTooltip] = useState(false)
  const [showPopup, setShowPopup] = useState(false)
  const [copied, setCopied] = useState(false)

  useEffect(() => {
    const today = new Date()
    const unlockDate = new Date(2026, 0, 28) // 28 Jan 2026

    if (today >= unlockDate) {
      setUnlocked(true)
    }
  }, [])

  const copyToClipboard = (text) => {
    navigator.clipboard.writeText(text)
    setCopied(true)
    setTimeout(() => setCopied(false), 2000)
  }

  return (
    <>
    <AdminNavbar />
    <div className="min-h-screen bg-gradient-to-br from-purple-900 via-indigo-900 to-black text-white flex flex-col items-center justify-center p-6">
      <div className="max-w-2xl w-full bg-white/10 backdrop-blur-md rounded-2xl shadow-lg p-8 border border-white/20 relative">
        <h1 className="text-3xl font-bold text-center mb-6 text-purple-300 animate-pulse">
          📖 Sakhi's Diary
        </h1>

        {/* Message Section */}
        <div className="p-6 bg-black/40 rounded-xl text-lg leading-relaxed text-gray-200 shadow-inner space-y-3">
          <p>
            Hello Sakhi, <br />
            Kuchh time ke liye mai diary ko close kar rha hu, thoda sa distraction khhatam krna hai isiliye mai pc ko band kar rha. <br />
            Sirf mobile use karunga ab!, I Hope Tum Aaoge Diary Check Krne Is Site Pe <span className="text-purple-400 font-semibold">28 Jan 2026</span> Ko. <br />
            I Hope Tum Bura Nhi Maanoge, Mere Paas tumhare liye ek surprice hai isiliye 28 Taarik ko jarur aana! <br />
            It's a request, btw sorry mai ek achha student na ban paaya shayad! <br />
            Thanks For Helping Me At Every Moment. Mai To Tumhare Dosti Ka Kabhi Rin Nhi Utar Paaunga. <br />
            I Hope tum maaf karoge. Aur Haaa behosh hona band karo aur Best Sakhi Ke Sath Best Lawyer Bhi Ban Ke DIkhao. <br />
            <strong>See You Again 💜</strong>
          </p>

          <p className="mt-4">Is Dono Link Ko Save Kar Lo Apne Notes Me:</p>

          {/* Stylish Copyable Links */}
          <div className="space-y-3">
            {["https://pyaridiary.snapcourse.in/", "https://snapcourse.in/secretme/aurandar/ayushi/bdday/"].map((link, i) => (
              <div key={i} className="flex items-center justify-between bg-black/50 px-4 py-2 rounded-lg shadow-inner border border-white/10">
                <code className="text-sm text-purple-300 truncate max-w-[75%]">{link}</code>
                <button
                  onClick={() => copyToClipboard(link)}
                  className="ml-3 px-3 py-1 text-xs rounded-md bg-purple-600 hover:bg-purple-700 transition-all text-white"
                >
                  {copied ? "✅ Copied" : "📋 Copy"}
                </button>
              </div>
            ))}
          </div>
        </div>

        {/* Anchor (Blurred until 28 Jan 2026) */}
        <div className="mt-6 text-center relative inline-block">
          <a
            href={unlocked ? "https://snapcourse.in/secretme/aurandar/ayushi/bdday/" : "#"}
            onClick={(e) => {
              if (!unlocked) {
                e.preventDefault()
                setShowPopup(true)
              }
            }}
            onMouseEnter={() => !unlocked && setShowTooltip(true)}
            onMouseLeave={() => setShowTooltip(false)}
            className={`px-6 py-3 rounded-xl font-semibold text-black transition-all duration-500 shadow-lg relative ${
              unlocked
                ? "bg-purple-300 hover:bg-purple-400 hover:scale-105 animate-bounce"
                : "bg-purple-300/80 backdrop-blur-sm filter blur-sm"
            }`}
          >
            💌 Open Message
          </a>

          {/* Tooltip */}
          {!unlocked && showTooltip && (
            <div className="absolute -top-14 left-1/2 -translate-x-1/2 bg-black/80 text-white text-sm px-4 py-2 rounded-lg shadow-lg animate-fadeIn whitespace-nowrap">
              🔒 Unlocks on <span className="text-purple-300 font-semibold">28 Jan 2026</span>
            </div>
          )}
        </div>
      </div>

      {/* Popup */}
      {showPopup && !unlocked && (
        <div className="fixed inset-0 bg-black/70 flex items-center justify-center z-50 p-4">
          <div className="bg-white text-black p-8 rounded-2xl shadow-2xl max-w-md w-full text-center animate-zoomIn">
            <h2 className="text-2xl font-bold mb-4">⏳ Not Yet!</h2>
            <p className="mb-6 text-lg">
              This diary will unlock on <span className="text-purple-600 font-semibold">28 Jan 2026</span>. Please come back then 💜
            </p>
            <button
              onClick={() => setShowPopup(false)}
              className="px-6 py-2 rounded-xl bg-purple-600 text-white hover:bg-purple-700 transition-all"
            >
              Okay, Got it!
            </button>
          </div>
        </div>
      )}

      {/* Custom Animations */}
      <style>{`
        @keyframes fadeIn {
          from { opacity: 0; transform: translateY(-5px); }
          to { opacity: 1; transform: translateY(0); }
        }
        .animate-fadeIn {
          animation: fadeIn 0.3s ease-out;
        }

        @keyframes zoomIn {
          from { opacity: 0; transform: scale(0.9); }
          to { opacity: 1; transform: scale(1); }
        }
        .animate-zoomIn {
          animation: zoomIn 0.3s ease-out;
        }
      `}</style>
    </div>
    </>
  )
}

export default AdminDashboard
